import React from 'react';
import { Form, Input, Button, Modal } from 'antd';
import { resetPassword } from 'actions/oldAccount';
import PropTypes from 'prop-types';
import IndexForm from 'components/IndexForm';
import { Link } from 'react-router-dom';
import queryString from 'query-string';

const FormItem = Form.Item;

class ResetPasswordOld extends React.Component {

    state = {

    }


    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const params = {
                    password:values['password'],
                    token:queryString.parse(this.props.location.search).token
                };
                resetPassword(params).then(e=>{
                    Modal.success({
                        title: 'Password reset successful, please login with your new password',
                        onOk: () => {
                            this.context.router.history.push('/login');
                        }
                    });
                }).catch(err=>{
                    err = err.data;
                    this.setState({errMsg:err.msg});
                });
            }
        });
    }

    render() {
        const { getFieldDecorator,getFieldValue } = this.props.form;
        return (
            <IndexForm title="Set Password" onSubmit={this.handleSubmit}>
                <div style={{ position: 'absolute', top: -25, color:'#f5222d'}}>{this.state.errMsg}</div>
                <FormItem>
                    {getFieldDecorator('password', {
                        rules: [
                            {validator:(rule, value, callback)=>{
                                if((value && value.length < 8) || !/[0-9]+/.test(value) || !/[a-zA-Z]+/.test(value)){
                                    callback('At least 8 characters, including letters and numbers!');
                                    return;
                                }
                                callback();
                            }}
                        ],
                        validateTrigger: 'onBlur'
                    })(
                        <Input type="password" placeholder="Please enter password" />
                    )}
                </FormItem>
                <FormItem>
                    {getFieldDecorator('passwordtwo', {
                        rules: [
                            {validator:(rule, value, callback)=>{
                                const pass = getFieldValue('password');
                                if(value !== pass){
                                    callback('Passwords do not match, please re-enter!');
                                    return;
                                }
                                callback();
                            }}
                        ],
                        validateTrigger: 'onBlur',
                    })(
                        <Input type="password" placeholder="Please enter password" />
                    )}
                </FormItem>
                <FormItem>
                    <Button type="primary" htmlType="submit">Reset Password</Button>
                    <Link to="/login">Back to Login</Link>
                </FormItem>
            </IndexForm>
        );
    }

}
ResetPasswordOld.contextTypes = {
    router: PropTypes.object
};

const WrappedForgetPassword = Form.create()(ResetPasswordOld);
export default WrappedForgetPassword;



// WEBPACK FOOTER //
// ./src/pages/ResetPasswordOld/index.js